//#region IMPORT
import React, { useState } from 'react';
/** Components Import */
import {
  Unstable_Grid2 as Grid,
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
} from '@mui/material';
import {
  AuthButton,
  DatePicker,
  Combo,
  Dialog,
  Button,
} from '../../../../Components/MUIs';
import { Close as CloseIcon, Save as SaveIcon } from '@mui/icons-material';

import Commons from '../../../../Services/Common/Common';

/** AG-grid Import */
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
/** Icons Import */

import dayjs from 'dayjs';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import ConfirmDialog from '../../../../Components/ConfirmDialog';
import { getColumnDefs1, getColumnDefs2 } from './LEG_BASIC_ColumnDefs';

//#endregion
function LEG_BASIC(props) {
  const [dialogToggle1, setDialogToggle1] = useState({
    open: false,
    title: '',
    contentText: '',
    onConfirm: null,
  });

  //기본정보그리드 컬럼
  const columnDefs1 = getColumnDefs1(props);
  // 법규준수평가 실시 팝업 컬럼
  const columnDefs2 = getColumnDefs2(props);
  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="LegalCompliance"
          searchYn="Y"
          saveYn="Y"
          addYn={'N'}
          addClick={() => {
            if (!props.validateSelection()) return;

            GridFunctions.addClick(props.gridRef1, props.setChangedRowData1);
          }}
          printClick={() => {
            if (!props.validateSelection()) return;

            props.PrintLogic1();
          }}
          searchClick={(e) => {
            if (!props.validateSelection()) return;

            props.setSearchText?.(e);
            props.gridRef1.current.api.setQuickFilter(e);
          }}
          deleteClick={(e) => {
            if (!props.validateSelection()) return;

            props.DeleteLogic1();
          }}
          saveClick={() => {
            if (!props.validateSelection()) return;
            props.SaveLogic1();
          }}
          conditions={[
            {
              type: 'datePicker',
              name: '조회연도',
              views: ['year'],
              openTo: 'year',
              title:
                props.lanList.length === 0
                  ? ''
                  : props.lanList.find(
                      (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'Period'
                    ).LAN_NM, //기간
              value: props.searchYear ? dayjs(props.searchYear) : dayjs(),
              onChange: (date) => {
                let changeYear = dayjs(date).format('YYYY');
                if (date) {
                  props.setSearchYear?.(changeYear);
                  props.SearchLogic1?.();
                }
              },
              currentLocale: 'ko',
              format: 'YYYY',
            },
            // ADMIN이면 추가 combo
            ...(props.userInfo.authCd === 'ADMIN'
              ? [
                  {
                    type: 'combo',
                    name: '회사',
                    items: props.searchInfo?.coList || [],
                    value: props.searchInfo?.coCd || '',
                    onChange: (e) => {
                      props.handleCoChange(e);
                      props.SearchLogic1();
                    },
                  },
                ]
              : []),
            {
              type: 'combo',
              name: '사업장',
              items: props.searchInfo?.custList || [],
              value: props.searchInfo?.custCd || '',
              onChange: (e) => {
                props.handleCustChange?.(e);
                props.SearchLogic1();
              },
            },
          ]}
          grids={
            <React.Fragment>
              <BusinessGridCommon
                getRowId={(params) => {
                  return params.data.no;
                }}
                addClick1={() => {
                  if (!props.validateSelection()) return;

                  props.PopupClickEvent1(props.inputs1);
                }}
                deleteClick1={(e) => {
                  if (!props.validateSelection()) return;

                  const newRowExists = props.selectedRowData1.some(
                    (row) => row.newYn === 'Y'
                  );

                  if (!newRowExists) {
                    props.MarkedForDeletion1(props.selectedRowData1);
                  } else {
                    props.NewYnErrorMsg();
                  }
                }}
                refreshClick1={() => {
                  if (!props.validateSelection()) return;

                  props.SearchLogic1();
                }}
                gridRef={props.gridRef1}
                editable={true}
                columnDefs={columnDefs1}
                rowData={props.rowData1}
                setSelectedRowData={props.setSelectedRowData1}
                setChangedRowData={props.setChangedRowData1}
                rowSelection={'multiple'}
                onCellClicked={(e) => {
                  // 체크박스 컬럼이 아닐때만 cellCLick 실행
                  if (e.colDef.field !== 'no') {
                    const newInputs = {
                      evaData1: e.data.startDt ?? e.data.lwEvaStartDt,
                      evaData2: e.data.endDt ?? e.data.lwEvaEndDt,
                      halfYear: e.data.evalHalf ?? e.data.lwBranch,
                    };

                    props.setInputs1(newInputs);
                    props.PopupClickEvent1(newInputs);
                  }
                }}
                onSelectionChanged={() => {
                  const gridApi = props.gridRef1?.current?.api;
                  const selectedNodes = gridApi.getSelectedNodes();
                  const selectedData = selectedNodes.map((n) => n.data);
                  props.selectedRowNosRef1.current = new Set(
                    selectedData.map((r) => r.no)
                  );
                  props.setSelectedRowData1(selectedData);
                }}
              />
              {/* 법규준수평가 실시 */}
              {props.modalToggle1 && (
                <div
                  role="presentation"
                  className="MuiDialog-root MuiModal-root"
                  inert="true"
                >
                  <Dialog
                    fullScreen
                    title={
                      <AppBar
                        sx={{
                          color: '#fff',
                          backgroundColor: '#2CA900',
                          position: 'static',
                        }}
                      >
                        <Toolbar>
                          <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => props.setModalToggle1(false)}
                            aria-label="close"
                            sx={{ marginRight: 2 }}
                          >
                            <CloseIcon />
                          </IconButton>
                          <Typography
                            sx={{
                              ml: 2,
                              flex: 1,
                              textAlign: 'left',
                            }}
                            variant="h6"
                            component="div"
                          >
                            <Box
                              sx={{
                                whiteSpace: 'normal',
                                overflow: 'visible',
                                textOverflow: 'clip',
                                wordWrap: 'break-word',
                              }}
                            >
                              {'법규준수평가 실시'}
                            </Box>
                          </Typography>
                          <Button
                            sx={{
                              mr: 1,
                              color: '#2CA900',
                              borderColor: '#2CA900',
                              backgroundColor: '#fff',
                              '&:hover': {
                                backgroundColor: '#249100', // hover 시 배경색
                                color: '#fff',
                              },
                            }}
                            name={
                              <>
                                <SaveIcon
                                  fontSize={Commons.IsMobile() ? 'small' : ''}
                                />
                                저장
                              </>
                            }
                            onClick={(e) => {
                              props.SaveLogic2();
                            }}
                            variant="outlined"
                          />
                        </Toolbar>
                      </AppBar>
                    }
                    open={props.modalToggle1}
                    onClose={(e) => props.setModalToggle1(false)}
                    contentSx={{ mx: 2 }}
                    content={
                      <div
                        className="ag-theme-alpine no-scroll"
                        style={{ height: '100%', width: '100%' }}
                      >
                        <BusinessGridCommon
                          getRowId={(params) => {
                            return params.data.no;
                          }}
                          stopEditingWhenCellsLoseFocus={false}
                          other1={
                            <React.Fragment>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <Combo
                                  name="상/하반기"
                                  size="small"
                                  items={[
                                    {
                                      value: '상반기',
                                      name: '상반기',
                                    },
                                    {
                                      value: '하반기',
                                      name: '하반기',
                                    },
                                  ]}
                                  wrapSx={{
                                    mx: 1,
                                    width: '200px',
                                  }}
                                  value={props.inputs1.halfYear}
                                  onChange={(e) => {
                                    const hasRealChanges =
                                      props.changedModalRowData1.some(
                                        (row) => row.editYn === 'Y'
                                      );
                                    const hasDeletions =
                                      props.deletedModalRowData1.length > 0;

                                    if (hasRealChanges || hasDeletions) {
                                      // props.changedModalRowData1.length > 0 ||
                                      // props.deletedModalRowData1.length > 0
                                      setDialogToggle1({
                                        open: true,
                                        title: '변경 확인',
                                        contentText:
                                          '변경된 사항이 있습니다. 무시하고 진행하시겠습니까?',
                                        onConfirm: () => {
                                          const newInputs = {
                                            ...props.inputs1,
                                            halfYear: e,
                                          };
                                          props.setInputs1(newInputs);
                                          props.SearchLogic2(newInputs);
                                          props.setChangedModalRowData1([]);
                                          setDialogToggle1((prev) => ({
                                            ...prev,
                                            open: false,
                                          }));
                                        },
                                      });
                                      return; // 확인 후 진행
                                    }

                                    const newInputs = {
                                      ...props.inputs1,
                                      halfYear: e,
                                    };

                                    props.setInputs1(newInputs);
                                    props.SearchLogic2(newInputs); // 새 값으로 호출
                                  }}
                                />
                                <DatePicker
                                  name="점검기간(시작)"
                                  defaultValue={
                                    props.inputs1.evaData1
                                      ? dayjs(props.inputs1.evaData1)
                                      : dayjs()
                                  }
                                  onChange={(date) => {
                                    let changeYear =
                                      dayjs(date).format('YYYY-MM-DD');
                                    if (date) {
                                      // 시간을 제거하고 "yyyy-MM-dd" 형식으로 변환하여 저장
                                      props.setInputs1({
                                        ...props.inputs1,
                                        evaData1: changeYear,
                                      });
                                    }
                                  }}
                                  currentLocale={'ko'}
                                  sx={{ width: '200px', mx: 1 }}
                                  slotProps={{
                                    textField: { size: 'small' },
                                  }}
                                />
                                <DatePicker
                                  name="평가기간(종료)"
                                  defaultValue={
                                    props.inputs1.evaData2
                                      ? dayjs(props.inputs1.evaData2)
                                      : dayjs()
                                  }
                                  onChange={(date) => {
                                    let changeYear =
                                      dayjs(date).format('YYYY-MM-DD');
                                    if (date) {
                                      // 시간을 제거하고 "yyyy-MM-dd" 형식으로 변환하여 저장
                                      props.setInputs1({
                                        ...props.inputs1,
                                        evaData2: changeYear,
                                      });
                                    }
                                  }}
                                  currentLocale={'ko'}
                                  sx={{ width: '200px', mx: 1 }}
                                  slotProps={{
                                    textField: { size: 'small' },
                                  }}
                                />
                              </div>
                            </React.Fragment>
                          }
                          addClick1={(e) => {
                            GridFunctions.addClick(
                              props.gridRef2,
                              props.setChangedModalRowData1
                            );
                          }}
                          refreshClick1={(e) => {
                            props.SearchLogic2(props.inputs1);
                          }}
                          deleteClick1={(e) => {
                            // 신규행은 "삭제예정" 처리 대신 즉시 제거(다른 화면들과 동일 UX)
                            const selected = props.selectedModalRowData1 || [];
                            const newRows = selected.filter(
                              (row) => row.newYn === 'Y'
                            );
                            const normalRows = selected.filter(
                              (row) => row.newYn !== 'Y'
                            );

                            newRows.forEach((row) => {
                              props.DeleteNewRow2?.(row);
                            });

                            if (normalRows.length > 0) {
                              props.MarkedForDeletion2(normalRows);
                            }
                          }}
                          fileUploadYn1="Y"
                          fileUploadClick1={() => {
                            if (!props.modalToggle1) return;
                            if (!props.validateSelection?.()) return;
                            props.fileInputRefModal2?.current?.click();
                          }}
                          fileDownloadYn1="Y"
                          fileDownloadClick1={() => {
                            if (!props.modalToggle1) return;
                            if (!props.validateSelection?.()) return;
                            props.ExcelDownload2?.();
                          }}
                          title1={'법규준수평가 실시'}
                          gridRef={props.gridRef2}
                          editable={true}
                          columnDefs={columnDefs2}
                          rowData={props.modalRowData1}
                          setSelectedRowData={props.setSelectedModalRowData1}
                          setChangedRowData={props.setChangedModalRowData1}
                          rowSelection={'multiple'}
                          onCellClicked={(e) => {
                            // 필요 시 특정 행 선택 등 처리
                            const gridApi = props.gridRef2.current.api;
                            const clickedRowIndex = e.rowIndex;

                            // GridCheckBox(MUI/커스텀)는 클릭 타겟이 svg/span일 수 있어
                            // input[type=checkbox]로만 판단하면 체크가 한번에 안되는 이슈가 생김.
                            const isCheckboxCol = e.colDef?.field === 'no';
                            const isCheckboxClick =
                              !!e.event?.target?.closest?.(
                                'input[type="checkbox"]'
                              );

                            // 체크박스(선택) 컬럼 클릭은 row-click 로직을 태우지 않는다.
                            if (isCheckboxCol || isCheckboxClick) return;

                            if (!isCheckboxClick) {
                              gridApi.ensureIndexVisible(
                                clickedRowIndex,
                                'middle'
                              );
                              const focusCol =
                                e.colDef?.field &&
                                e.colDef.field !== 'no'
                                  ? e.colDef.field
                                  : 'lwNm';

                              const copied = JSON.parse(JSON.stringify(e.data));
                              props.handleRowSelection2(
                                copied,
                                clickedRowIndex
                              );

                              gridApi
                                .getDisplayedRowAtIndex(clickedRowIndex)
                                ?.setSelected(true, false);

                              // setFocusedCell을 즉시 호출하면 singleClickEdit로 열리던 편집이 취소됨 →
                              // 텍스트/멀티라인 컬럼은 다음 프레임에 편집 시작
                              const editableFields = new Set([
                                'lwNm',
                                'checkItem',
                                'checkContent',
                                'remark',
                              ]);
                              if (editableFields.has(focusCol)) {
                                requestAnimationFrame(() => {
                                  const api = props.gridRef2.current?.api;
                                  if (!api) return;
                                  api.startEditingCell({
                                    rowIndex: clickedRowIndex,
                                    colKey: focusCol,
                                  });
                                });
                              } else {
                                gridApi.setFocusedCell(
                                  clickedRowIndex,
                                  focusCol
                                );
                              }
                            }
                          }}
                          onSelectionChanged={() => {
                            const gridApi = props.gridRef2?.current?.api;
                            const selectedNodes = gridApi.getSelectedNodes();
                            const selectedData = selectedNodes.map(
                              (n) => n.data
                            );
                            props.selectedModalRowNosRef1.current = new Set(
                              selectedData.map((r) => r.no)
                            );
                            props.setSelectedModalRowData1(selectedData);
                          }}
                        />
                        <input
                          type="file"
                          ref={props.fileInputRefModal2}
                          style={{ display: 'none' }}
                          accept=".xlsx,.xls"
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) {
                              props.ExcelUpload2?.(file);
                              e.target.value = '';
                            }
                          }}
                        />
                        <ConfirmDialog
                          open={dialogToggle1.open}
                          title={dialogToggle1.title}
                          contentText={dialogToggle1.contentText}
                          onSave={dialogToggle1.onConfirm}
                          onClose={() =>
                            setDialogToggle1((prev) => ({
                              ...prev,
                              open: false,
                            }))
                          }
                          saveButtonName="확인"
                          closeButtonName="취소"
                        />
                      </div>
                    }
                    useCloseButton={false}
                    onSave={() => {}}
                    maxWidth="sm"
                  />
                </div>
              )}
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  );
}

export default LEG_BASIC;
